<template>
  <ul>
    <li class="head">
      <h1 v-if="useNativeLinksInLogo && useNativeLinks">
        <a href="/" title="Ylands">
          <YlandsLogo />
        </a>
      </h1>
      <h1 v-else>
        <router-link :to="{ name: 'home' }" title="Ylands" class="logo">
          <YlandsLogo />
        </router-link>
      </h1>
      <CloseBtn
        v-if="showHamburgerMenu"
        @click="toggleBurgerMenu"
        class="nav-close-icon"
      />
    </li>
    <li v-if="userData" class="hoverActive" @click="toggleUserAccountMenu">
      <Account
        :login-url="loginUrl"
        :logout-url="logoutUrl"
        :user-data-url="userDataUrl"
        :user="userData"
      />
      <div class="chevron">
        <Chevron />
      </div>
    </li>

    <li v-else>
      <Account
        :login-url="loginUrl"
        :logout-url="logoutUrl"
        :user-data-url="userDataUrl"
        :user="userData"
      />
    </li>

    <li>
      <a
        :class="{ 'router-link-active': alwaysActiveLink === 'play' }"
        v-if="useNativeLinks"
        title="Play Ylands"
        href="https://play.ylands.com/"
        >Play</a
      >
      <a
        v-else
        :class="{ 'router-link-active': alwaysActiveLink === 'play' }"
        href="/play"
        title="Play Ylands"
        >Play</a
      >
    </li>

    <li>
      <a
        :class="{
          'router-link-active': alwaysActiveLink === 'create'
        }"
        v-if="useNativeLinks"
        title="CreateYlands"
        href="https://create.ylands.com/"
        >Create</a
      >
      <a
        v-else
        :class="{ 'router-link-active': alwaysActiveLink === 'create' }"
        href="/create"
        title="Create Yalnds"
        >Create</a
      >
    </li>

    <li>
      <a
        v-if="useNativeLinks"
        title="Ylands News"
        href="https://ylands.com/news"
        >News</a
      >
      <router-link
        class="nav-links"
        v-else
        :to="{ name: 'news' }"
        title="Ylands News"
        >News</router-link
      >
    </li>

    <li>
      <a
        v-if="useNativeLinks"
        title="Ylands F.A.Q"
        href="https://ylands.com/faq"
        >FAQ</a
      >
      <router-link
        v-else
        class="nav-links"
        :to="{ name: 'faq' }"
        title="Ylands F.A.Q"
        >FAQ</router-link
      >
    </li>

    <li>
      <a
        :class="{
          'router-link-active': alwaysActiveLink === 'community'
        }"
        v-if="useNativeLinks"
        title="Ylands Community Forums"
        href="https://ylands.com/community"
        >Community <OutsideLinkIcon class="outside-link-icon"
      /></a>
      <a
        v-else
        :class="{
          'router-link-active': alwaysActiveLink === 'community'
        }"
        href="/community"
        title="Ylands Community Forums"
        >Community <OutsideLinkIcon class="outside-link-icon"
      /></a>
    </li>
    <li>
      <a title="Bohemia Interactive Store" href="https://store.bistudio.com/"
        >Merch
        <OutsideLinkIcon class="outside-link-icon" />
      </a>
    </li>
  </ul>
</template>
<script>
import OutsideLinkIcon from "../../assets/svg/outside_link.svg?inline";
import Chevron from "../../assets/svg/chevron.svg?inline";
import Account from "./Account";
import CloseBtn from "../../assets/svg/close.svg?inline";
import YlandsLogo from "./../icons/YlandsLogo";

export default {
  name: "hamburger-menu",
  data() {
    return {
      userAccountMenu: false,
      showBurger: true
    };
  },
  props: {
    userDataUrl: {
      type: String
    },
    userData: {
      type: Object
    },
    loginUrl: {
      type: String
    },
    logoutUrl: {
      type: String
    },
    alwaysActiveLink: {
      type: String
    },
    useNativeLinks: {
      type: Boolean,
      default: true
    },
    showUserAccountMenu: {
      type: Boolean,
      default: false
    },
    showHamburgerMenu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OutsideLinkIcon,
    Account,
    Chevron,
    CloseBtn,
    YlandsLogo
  },
  methods: {
    toggleBurgerMenu() {
      this.showBurger = !this.showBurger;
      this.$emit("showHamburgerMenu", this.showBurger);
    },
    toggleUserAccountMenu() {
      if (this.userData != null) {
        this.userAccountMenu = !this.userAccountMenu;
        this.$emit("showUserAccountMenu", this.userAccountMenu);
      }
    }
  }
};
</script>

<style scoped lang="scss">
#nav-hamburger-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  list-style-type: none;
  padding: 0;
  margin: 0;
  padding-right: 0.4em;

  .head {
    justify-content: space-between;
    align-items: start;

    .nav-close-icon {
      display: flex;
      cursor: pointer;
    }

    h1 {
      margin: 0;
    }
  }

  li {
    display: flex;
    flex: 0.1;
    padding: 1em 0;
    align-items: center;
    font-size: 1em;
    font-family: "Istok Web", sans-serif;
    cursor: pointer;

    &:hover {
      text-shadow: 0 0 1px #fff;
    }

    .outside-link-icon {
      margin-left: 5px;
    }
  }

  @media (min-width: 551px) and (max-width: 980px) {
    li {
      a {
        font-size: 1.5em;
      }

      .nav-links {
        font-size: 1.5em;
      }
    }
  }

  .hoverActive {
    cursor: pointer;
    &:hover {
      text-shadow: 0 0 0.5px #fff;
      filter: drop-shadow(0 0 0.75rem #fff);
    }
  }
}
</style>
